export default {
     categories(state) {
          return state.categories;
     },
     quizzes(state) {
          return state.quizzes;
     }
};